module.exports = require('edge/platform/transport/TransportDefaultService')


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/plugin?transport-service!../common/js/src/edge/platform/transport/TransportDefaultService.js
// module id = 477
// module chunks = 0